export default {
    staging: {
        puzzleDataApi: "https://embed.puzzlexperts.com/api/",
        testClientAppIds: {
            codecracker: 28,
            //crossword: 11, // quick
            //crossword: 5, // universal
            //crossword: 16, // daily classic
            crossword: 32, // enigma
            //crossword: 10, // cryptic
            //crossword: 13, // elevenses
            //crossword: 12, // giant
           // crossword: 172, //american
           //crossword: 173, //memory lane
            //sudoku: 4, // classic sudoku
            //sudoku: 148, // addoku
           sudoku: 9, // shapeshifter
           // sudoku: 8, // windoku
           // sudoku: 7, // XSudoku 
            trivia: 14,
            wordsearch: 6,
        }
    },
    production: {
        //puzzleDataApi: "https://data.v2.puzzlexperts.com/api/",
        puzzleDataApi: "https://embed.puzzlexperts.com/api/",
    },
}